import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { validateShipmentTrackingNumber } from '../../helpers/formHelpers/formHelpers';
import { getQueryParam } from '../../helpers/url/urlHelpers';
import usePostCodes from '../../hooks/usePostCodes';
import Button from '../base/button';
import FormikFieldWrapper from '../base/forms/formikFieldWrapper';
import FormikSelect from '../base/forms/formikSelect';
import { StyledFormikField } from '../base/forms/input';
import { Column, Columns } from '../base/grid';
import Error from '../error';
import { RawLoader } from '../loading/loading';

interface Props {
	values: any;
	setFieldTouched: any;
	setFieldValue: any;
	isSubmitting: boolean;
	errors: any;
	touched: any;
}

const HomeDeliveryFormFields: FC<Props> = ({
	values,
	setFieldTouched,
	setFieldValue,
	isSubmitting,
	// errors,
	// touched,
}) => {
	const { t } = useTranslation('generalForm');
	const { postCodes, postCodesLoading, postCodesError } = usePostCodes();
	const query = getQueryParam('q');
	const [showMultiHint, setShowMultiHint] = useState(false);

	useEffect(() => {
		if (query && validateShipmentTrackingNumber(query)) {
			setFieldValue('trackingnumber', query);
			setShowMultiHint(true);
		}
	}, [query, setFieldValue]);

	useEffect(() => {
		if (values.trackingnumber.length > 0) {
			setShowMultiHint(true);
		} else {
			setShowMultiHint(false);
		}
	}, [values.trackingnumber]);

	useEffect(() => {
		if (query && validateShipmentTrackingNumber(query)) setFieldValue('trackingnumber', query);
	}, [query, setFieldValue]);

	if (postCodesLoading) return <RawLoader />;

	if (postCodesError) return <Error />;

	return (
		<div>
			<Columns>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="trackingnumber"
						languageComponent="generalForm"
						label={`${t('trackingnumber')} *`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="trackingnumber"
							name="trackingnumber"
							placeholder={t('trackingnumber')}
						/>
						{showMultiHint && (
							<small style={{ display: 'block', marginTop: '4px', color: '#666666' }}>
								{t('enterCommas')}
							</small>
						)}
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper name="name" languageComponent="generalForm" label={`${t('name')} *`} smallLabel>
						<StyledFormikField type="text" id="name" name="name" placeholder={t('name')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="address"
						languageComponent="generalForm"
						label={`${t('address')} *`}
						smallLabel>
						<StyledFormikField type="text" id="address" name="address" placeholder={t('address')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper label={`${t('zip')} *`} smallLabel name="zip" languageComponent="generalForm">
						<FormikSelect
							id="zip"
							name="zip"
							value={values.zip}
							options={postCodes}
							placeholder={t('zip')}
							onBlur={setFieldTouched}
							onChange={setFieldValue}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="customerEmail"
						languageComponent="generalForm"
						label={`${t('email')} *`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="customerEmail"
							name="customerEmail"
							placeholder={t('email')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="phone"
						languageComponent="generalForm"
						label={`${t('phone')} *`}
						smallLabel>
						<StyledFormikField type="number" id="phone" name="phone" placeholder={t('phone')} />
					</FormikFieldWrapper>
				</Column>

				{/* <Column>
					<Captcha
						schemaName="captchaValid"
						setFieldTouched={setFieldTouched}
						setFieldValue={setFieldValue}
						errors={errors}
						touched={touched}
					/>
				</Column> */}
			</Columns>

			<Columns>
				<Column>
					<Button wide primary type="submit" isLoading={isSubmitting}>
						{t('submit')}
					</Button>
				</Column>
			</Columns>
		</div>
	);
};

export default HomeDeliveryFormFields;
